import { render, staticRenderFns } from "./UpdatePasswordView.vue?vue&type=template&id=1d920c0c"
import script from "./UpdatePasswordView.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports